// extracted by mini-css-extract-plugin
export default {"grey200":"#eeeeee","demo":"TabsPanel_demo__W4bSt"};